(function () {
  'use strict';

  angular
    .module('factories.authProvider', ['factories.storage', 'factories.serviceLocator', 'factories.mobileHelper'])
    .factory('Auth', Auth);

  Auth.$inject = ['Storage', '$http', '$window', 'serviceLocator'];

  function Auth(Storage, $http, $window, serviceLocator) {
    var o;
    var keysToDestroy = ['numAccounts', 'selectedAccount', 'user', 'password', 'quizAnswers', 'labelingImagesOrder',
      'lastSelectedTrainerCModuleId', 'lastSelectedTraineeCModuleId', 'lastSelectedTraineeSeriesId',
      'lastSelectedDashboardTab', 'allAccounts', 'traineeDomain'
    ];

    var userRoles = {
      trainee: 'Trainee',
      reporter: 'Reporter',
      teamLead: 'TeamLead',
      manager: 'Manager',
      trainer: 'Trainer',
      administrator: 'Administrator',
      owner: 'Owner',
      sme: 'SME',
      anonymous: 'Anonymous'
    };

    function setSelectedAccount(account) {
      var firstName = account ? account.firstName : null;
      var email = account ? account.email : null;
      Storage.setValue('firstName', firstName);
      Storage.setValue('email', email);
      Storage.setValue('selectedAccount', account);
    }

    function setDomain(domain) {
      Storage.setValue('traineeDomain', domain);
      $window.mfConfig.traineeDomain = domain;
    }

    function getDomain() {
      return Storage.getValue('traineeDomain');
    }

    function setCredentials(credentials) {
      var user = {email: credentials.email};
      Storage.setValue('user', user);
    }

    function clear() {
      delete $http.defaults.headers.common['X-Mindflash-SessionID'];
      delete $http.defaults.headers.common['x-mf-sess'];
      _.each(keysToDestroy, function (key) {
        delete o[key];
        Storage.clearValue(key);
      });
    }

    function logout() {
      serviceLocator.logout({saveEmail: false});
    }

    function logoutSaveEmail() {
      serviceLocator.logout({saveEmail: true});
    }

    function clearSaveEmail() {
      var user = Storage.getValue('user');
      clear();
      if (user) {
        Storage.setValue('user', user);
      }
    }

    function userIsLoggedIn() {
      return !!Storage.getValue('selectedAccount');
    }

    function userIsTeamMember() {
      return userIsLoggedIn() &&
        userHasRole([userRoles.owner, userRoles.administrator, userRoles.trainer, userRoles.manager, userRoles.teamLead, userRoles.reporter]);
    }

    function userCanPreviewCModules() {
      return userIsLoggedIn() &&
        userHasRole([userRoles.owner, userRoles.administrator, userRoles.trainer, userRoles.manager]);
    }

    function userHasRole(roles) {
      if (!userIsLoggedIn()) return false;
      if (!_.isArray(roles)) roles = [roles];

      var currentRole = Storage.getValue('selectedAccount').role;

      for (var i = 0, c = roles.length; i < c; i++) {
        if (roles[i] == currentRole) return true;
      }

      return false;
    }

    function userIsTrainee() {
      return userIsLoggedIn() && Storage.getValue('selectedAccount').role == userRoles.trainee;
    }

    function getHeaderSessionId() {
      return $http.defaults.headers.common['x-mf-sess'] || $http.defaults.headers.common['x-mindflash-sessionid'];
    }

    function setHeaderSessionId(value) {
      $http.defaults.headers.common['x-mf-sess'] = value;
    }

    function setOldHeaderSessionId(value) {
      $http.defaults.headers.common['x-mindflash-sessionid'] = value;
    }

    function deleteHeaderSessionId() {
      delete $http.defaults.headers.common['x-mf-sess'];
      delete $http.defaults.headers.common['x-mindflash-sessionid'];
    }

    o = {
      getHeaderSessionId: getHeaderSessionId,
      getSelectedAccount: Storage.getValue.bind(null, 'selectedAccount'),
      setSelectedAccount: setSelectedAccount,
      setCredentials: setCredentials,
      getCredentials: Storage.getValue.bind(null, 'user'),
      getFirstName: Storage.getValue.bind(null, 'firstName'),
      logout: logout,
      logoutSaveEmail: logoutSaveEmail,
      clear: clear,
      clearSaveEmail: clearSaveEmail,
      userIsLoggedIn: userIsLoggedIn,
      userIsTeamMember: userIsTeamMember,
      userCanPreviewCModules: userCanPreviewCModules,
      userIsTrainee: userIsTrainee,
      setHeaderSessionId: setHeaderSessionId,
      setOldHeaderSessionId: setOldHeaderSessionId,
      deleteHeaderSessionId: deleteHeaderSessionId,
      userHasRole: userHasRole,
      userRoles: userRoles,
      useYammer: false,
      setDomain: setDomain,
      getDomain: getDomain
    };

    return o;
  }

})();
